/**
 * 对官网顶部=菜单进行初始化
 * 菜单的数据统一放到 snippets\lepro-menu-json.liquid 文件中
 */

const htmlItems = {}
const childItems = {}

// ── 产品图片懒加载 + 后台预取 ───────────────────────────────
// 从 /products/{handle} 格式的链接中提取 handle
function getProductHandle(link) {
    if (!link || !link.includes('/products/')) return ''
    return link.split('/products/')[1].split('?')[0].split('#')[0]
}

// sessionStorage 缓存，同一 session 内不重复请求
let _productImgCache = {}
try { _productImgCache = JSON.parse(sessionStorage.getItem('le_product_imgs') || '{}') } catch(e) {}

// 进行中的 fetch Promise 池，避免同一 handle 重复请求
const _fetchPromises = {}

// 请求单个产品图片，返回 Promise<url>（自动去重）
function fetchProductImage(handle) {
    if (_productImgCache[handle] !== undefined) return Promise.resolve(_productImgCache[handle])
    if (_fetchPromises[handle]) return _fetchPromises[handle]
    _fetchPromises[handle] = fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json() })
        .then(function(data) {
            const url = data.featured_image || ''
            _productImgCache[handle] = url
            try { sessionStorage.setItem('le_product_imgs', JSON.stringify(_productImgCache)) } catch(e) {}
            return url
        })
        .catch(function() { _productImgCache[handle] = ''; return '' })
    return _fetchPromises[handle]
}

// 填充容器内所有 data-handle 图片（复用已有 Promise，不重复 fetch）
function loadProductImages(container) {
    if (!container) return
    container.querySelectorAll('img[data-handle]').forEach(function(img) {
        const handle = img.getAttribute('data-handle')
        if (!handle) return
        fetchProductImage(handle).then(function(url) { if (url) img.src = url })
    })
}

// 页面加载后后台静默预取所有菜单产品图片，用户 hover 时直接从缓存秒显
function preloadAllProductImages() {
    const handles = new Set()
    function collect(items) {
        if (!items) return
        items.forEach(function(item) {
            const h = getProductHandle(item.link)
            if (h) handles.add(h)
            collect(item.links)
            collect(item.scenes)
        })
    }
    collect(window.menusList)
    handles.forEach(function(handle) { fetchProductImage(handle) })
}

// 生成 <img> 标签：有 img_url 直接用；没有则按 link 提取 handle 懒加载
function imgTag(obj) {
    if (obj.img_url) return `<img src="${obj.img_url}" alt="${obj.title || ''}" class="img">`
    const handle = getProductHandle(obj.link)
    return `<img src="" data-handle="${handle}" alt="${obj.title || ''}" class="img">`
}
// ────────────────────────────────────────────────────────────

const headerMobileNode = $('.header-section-m')
const popupHeaderNode = headerMobileNode.find('.le-popup--header')
const mobileMenuHistory = []

const headerPcNode = $('.header-section-pc')
const navPopupSection = $('.nav-popup-section')
const navPopupBackground = $('.nav-popup-background')

initHeaderHtml()
bindClick()
initHeaderDrawerLayout()

// Fit the drawer below its actual top, including promo bars and the mobile browser UI.
function initHeaderDrawerLayout() {
    const drawer = headerMobileNode.find('#menu-drawer')[0]
    if (!drawer) return

    const details = drawer.closest('details')
    const header = drawer.closest('.le-header')
    let pendingFrame = null

    function updateHeight() {
        pendingFrame = null
        if (!details.open) return

        const viewport = window.visualViewport
        const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight
        const height = Math.max(0, viewportBottom - drawer.getBoundingClientRect().top)
        drawer.style.setProperty('--le-menu-drawer-height', `${height}px`)
    }

    function scheduleUpdate() {
        if (!details.open || pendingFrame !== null) return
        pendingFrame = requestAnimationFrame(updateHeight)
    }

    details.addEventListener('toggle', scheduleUpdate)
    window.addEventListener('resize', scheduleUpdate)
    window.addEventListener('scroll', scheduleUpdate, { passive: true })
    if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleUpdate)
        window.visualViewport.addEventListener('scroll', scheduleUpdate)
    }
    if (header) {
        // The promo bar synchronizer changes the fixed header's top through inline styles.
        new MutationObserver(scheduleUpdate).observe(header, { attributes: true, attributeFilter: ['style'] })
        if (window.ResizeObserver) new ResizeObserver(scheduleUpdate).observe(header)
    }
    scheduleUpdate()
}

// 页面空闲后后台预取菜单产品图片，优先使用 requestIdleCallback 不占主线程
if (window.requestIdleCallback) {
    requestIdleCallback(preloadAllProductImages)
} else {
    setTimeout(preloadAllProductImages, 800)
}

/**
 * 1. 组合菜单数据结构
 * 2. 初始化第一层菜单数据
 */
function initHeaderHtml () {
    let html = '<ul class="nav-menu-main nav-menu-section child-main-model">'
    let htmlPc = ''

    window.menusList.forEach((item) => {
        if (!htmlItems[item.title]) {
            htmlItems[item.title] = {
                links: item.links || [],
                link: item.link,
                id: item.title,
                scenes: item.scenes || [],
                title: item.title
            }
        }

        html += `<li class="li" data-id="${item.title}" data-type="${item.type}" data-link="${item.link}" data-title="${item.title}">
            <${ item.links && item.links.length > 0 ? "div" : `a href="${item.link}"` } class="link-list">
                <span class="text">${item.title}</span>
                ${ item.links && item.links.length > 0 ?
                    `<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>`
                    : ''
                }
            </${ item.links && item.links.length > 0 ? "div" : `a` }>
        </li>`

        htmlPc += `<li class="li" data-id="${item.title}" data-type="${item.type}"><a href="${item.link}" class="header__menu-item list-menu__item link link--text focus-inset">
        <span>${item.title}</span>
        </a></li>`
    })

    html += '</ul>'

    fillHtml(html, htmlPc)
}

function fillHtml (html, htmlPc) {
    const mobileNav = headerMobileNode.find('.menu-drawer__navigation')
    mobileNav.html(html)
    mobileNav.scrollTop(0)
    loadProductImages(mobileNav[0])
    if (htmlPc !== undefined) headerPcNode.find('.list-menu').html(htmlPc)
}
// Save the rendered level, including expanded accordions and its scroll position.
function rememberMobileMenu() {
    const nav = headerMobileNode.find('.menu-drawer__navigation')
    const shopAll = headerMobileNode.find('.all-btn-wrap')
    mobileMenuHistory.push({
        html: nav.html(),
        scrollTop: nav.scrollTop(),
        title: popupHeaderNode.find('.title-name').text(),
        headerDisplay: popupHeaderNode.css('display'),
        shopAllDisplay: shopAll.css('display'),
        shopAllHref: shopAll.find('.all-link').attr('href')
    })
}

function restoreMobileMenu(state) {
    const shopAll = headerMobileNode.find('.all-btn-wrap')
    popupHeaderNode.find('.title-name').text(state.title)
    popupHeaderNode.css('display', state.headerDisplay)
    shopAll.css('display', state.shopAllDisplay)
    if (state.shopAllHref === undefined) shopAll.find('.all-link').removeAttr('href')
    else shopAll.find('.all-link').attr('href', state.shopAllHref)
    fillHtml(state.html)
    headerMobileNode.find('.menu-drawer__navigation').scrollTop(state.scrollTop)
}

function resetMobileMenu() {
    const root = mobileMenuHistory[0]
    mobileMenuHistory.length = 0
    if (root) restoreMobileMenu(root)
    popupHeaderNode.hide()
    popupHeaderNode.find('.title-name').text('')
    headerMobileNode.find('.all-btn-wrap').hide()
    headerMobileNode.find('.menu-drawer__navigation').scrollTop(0)
}

function fillChildHtml (htmlPc) {
    const container = navPopupSection.find('.le-nav-container')
    container.html(htmlPc)
    loadProductImages(container[0])
}

function bindClick () {
    // 绑定移动端的菜单点击事件
    headerMobileNode.on('click', '.nav-menu-main .li', function () {
        const dataType = $(this).attr('data-type') || ''
        const dataId = $(this).attr('data-id') || ''
        const dataTitle = $(this).attr('data-title') || ''
        const dataHref = $(this).find('a')

        if (dataHref.length > 0) return

        rememberMobileMenu()
        popupHeaderNode.css({ display: 'flex' })
        popupHeaderNode.find('.title-name').text(dataTitle)

        headerMobileNode.find('.all-btn-wrap').css({ display: 'none' })

        // 根据不同的菜单类目类型，展示不同的布局;
        switch (dataType) {
            case 'img-text':
                fillHtml(initImgTextM(htmlItems[dataId].links || []))
                break
            case 'up-down':
                headerMobileNode.find('.all-btn-wrap').css({ display: 'block' })
                headerMobileNode.find('.all-btn-wrap .all-link').attr('href', htmlItems[dataId].link)
                fillHtml(initUpDowntM(htmlItems[dataId].links || []))
                break
            case 'scene':
                headerMobileNode.find('.all-btn-wrap').css({ display: 'block' })
                headerMobileNode.find('.all-btn-wrap .all-link').attr('href', htmlItems[dataId].link)
                fillHtml(initSceneM(htmlItems[dataId]))
                break
            case 'up-down-text-img':
                fillHtml(initUpDowntImgTextM(htmlItems[dataId].links || []))
                break
            case 'other':
                fillHtml(initOtherM(htmlItems[dataId].links || []))
                break
        }
    })

    // 绑定移动端二级菜单点击拉下事件
    headerMobileNode.on('click', '.nav-menu-section .li-up-down', function () {
        const dataLength = $(this).attr('data-length')
        if (dataLength == '0') {
            window.location.href = $(this).attr('data-link')
            return
        }
        if ($(this).hasClass('active')) {
            $(this).removeClass('active')
            return
        }
        $(this).addClass('active')
    })

    // 绑定移动端 scene 分类点击事件（进入第二层 scenes）
    headerMobileNode.on('click', '.nav-menu-section .li-scene', function () {
        const dataId = $(this).attr('data-id')
        const hasScenes = $(this).attr('data-has-scenes') === 'true'
        const dataLink = $(this).attr('data-link')

        // 如果没有 scenes，直接跳转
        if (!hasScenes) {
            window.location.href = dataLink
            return
        }

        const childItem = childItems[dataId]
        if (childItem && childItem.scenes && childItem.scenes.length > 0) {
            rememberMobileMenu()
            // 更新标题
            popupHeaderNode.find('.title-name').text(childItem.title)
            // 隐藏 Shop All 按钮
            headerMobileNode.find('.all-btn-wrap').css({ display: 'none' })
            // 渲染第二层 scenes
            fillHtml(initSceneMChild(childItem))
        }
    })

    // 绑定移动端菜单弹窗的返回按钮
    popupHeaderNode.on('click', '#le_icon_arrow', function () {
        const previous = mobileMenuHistory.pop()
        if (previous) restoreMobileMenu(previous)
    })
    // 绑定移动端菜单弹窗的关闭按钮
    popupHeaderNode.on('click', '#close-btn', function () {
        $('.header-section-m .header__icon--summary').trigger('click')
        resetMobileMenu()
    })

    // Cover every native drawer close path: header toggle, Escape and focus handling.
    const drawerDetails = headerMobileNode.find('#menu-drawer')[0]?.closest('details')
    if (drawerDetails) {
        new MutationObserver(() => {
            if (!drawerDetails.open) resetMobileMenu()
        }).observe(drawerDetails, { attributes: true, attributeFilter: ['open'] })
    }

    // 绑定pc端一级菜单，鼠标划入时的事件
    headerPcNode.on('mouseenter', '.list-menu .li', function () {
        const dataId = $(this).attr('data-id') || ''
        $(this).siblings('.li').removeClass('active')

        if (!(htmlItems[dataId].links && htmlItems[dataId].links.length > 0)) {
            navPopupSection.css({ height: 0 })
            navPopupBackground.hide()
            return
        }

        $(this).addClass('active')

        const dataType = $(this).attr('data-type') || ''

        navPopupSection.removeClass('not-style')
        navPopupSection.addClass('nav-popup-hover')
        navPopupBackground.show()

        // 根据不同的菜单类目类型，展示不同的布局;
        switch (dataType) {
            case 'img-text':
                fillChildHtml(initImgTextPc(htmlItems[dataId].links))
                break
            case 'up-down':
                fillChildHtml(initUpDowntPc(htmlItems[dataId].links, htmlItems[dataId].link, htmlItems[dataId].title))
                break
            case 'scene':
                fillChildHtml(initScenePc(htmlItems[dataId], htmlItems[dataId].title))
                break
            case 'up-down-text-img':
                fillChildHtml(initUpDowntImgTextPc(htmlItems[dataId].links))
                break
            case 'other':
                navPopupSection.addClass('not-style')
                fillChildHtml(initOtherPc(htmlItems[dataId].links))
                navPopupSection.find('.child-nav-main').css({ left: $(this)[0].offsetLeft })
                break
        }
        navPopupSection.css({ height: navPopupSection.find('.le-nav-container .child-nav-main')[0].clientHeight })
    })

    // 绑定pc端二级菜单中左边的菜单划入事件 (up-down类型)
    navPopupSection.on('mouseenter', '.child-nav-main .menu-child .list-hover:not(.list-scene)', function () {
        $(this).siblings('.list').removeClass('active')
        $(this).addClass('active')
        const dataId = $(this).attr('data-id')
        const navActiveList = initActiveUpDowntPc(childItems[dataId])
        const updownListsEl = navPopupSection.find('.child-nav-main .menu-active-lists .lists')
        updownListsEl.html(navActiveList)
        loadProductImages(updownListsEl[0])
    })

    // 绑定pc端二级菜单中左边的菜单划入事件 (scene类型)
    navPopupSection.on('mouseenter', '.child-nav-main .menu-child .list-scene', function () {
        $(this).siblings('.list').removeClass('active')
        $(this).addClass('active')
        const dataId = $(this).attr('data-id')
        const childItem = childItems[dataId]

        if (childItem && childItem.scenes && childItem.scenes.length > 0) {
            const navActiveList = initActiveScenePcInner(childItem.scenes)
            const menuActiveEl = navPopupSection.find('.child-nav-main .menu-active-lists-model_2')

            // 更新产品列表
            const targetEl = menuActiveEl.find('.lists')
            if (targetEl.length > 0) {
                targetEl.html(navActiveList)
                loadProductImages(targetEl[0])
            }

            // 更新 title 和 View More 按钮
            const titleEl = menuActiveEl.find('.menu-title')
            if (titleEl.length > 0) {
                titleEl.html(`${childItem.title || dataId}<a href="${childItem.link || '#'}" class="view-all">View More ></a>`)
            }
        }
    })

    $('body').on('mouseleave', '.nav-popup-section', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })
    $('body').on('mouseenter', '.nav-popup-background', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })
    $('body').on('mouseenter', '.shopify-section .utility-bar', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })
    $('body').on('mouseleave', '.le-header', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })
    $('body').on('mouseenter', '.le-header .header__icons', function () {
        $('.header__inline-menu .list-menu .li').removeClass('active')
        navPopupSection.css({ height: 0 })
        navPopupBackground.hide()
    })

    const bodyWidth = document.querySelector('body').clientWidth || document.querySelector('html').offsetWidth
    if (bodyWidth > 0 && bodyWidth >= 990) {
        $('.header-section-pc .header-account__btn').on('mouseenter',function () {
            const dialogNode = $('.lepro-account-dialog .dialog-wrap')
            if (dialogNode.is(':visible')) {
                dialogNode.hide()
            } else {
                $('.lepro-account-dialog').css({ left: (this.offsetLeft + this.clientWidth + $('.header-section-pc')[0].offsetLeft - $('.lepro-account-dialog')[0].clientWidth)})
                dialogNode.show()
            }
        })
        $('.header-section-pc .header-account__btn').on('mouseleave',function () {
            $(this).find('.dialog-wrap').hide()
        })
    } else if (bodyWidth > 0 && bodyWidth < 990) {
        $('.header-section-m .header-account__btn').on('click',function () {
            $('.lepro-account-dialog').show()
        })
        $('.lepro-account-dialog').on('click',function (e) {
            e.stopPropagation();
            $(this).css({ display: 'none' })
        })
        $('.lepro-account-dialog .dialog-wrap').on('click',function (e) {
            e.stopPropagation();
        })
    }
}

// 移动端 img-text 类目的html结构
function initImgTextM (items) {
    let html = '<ul class="nav-menu-section child-main-model__2">'

    items.forEach(item => {
        html += `<li class="li">
            <a href="${item.link}" class="img-wrap">
                ${imgTag(item)}
            </a>
            <a href="${item.link}" class="li-title">${item.title}</a>
        </li>`
    })

    html += `</ul>`

    return html
}

// 移动端 up-down 类目的html结构
function initUpDowntM (items) {
    let html = '<ul class="nav-menu-section child-main-model child-main-model__3">'

    items.forEach(item => {
        html += `<li class="li li-up-down ${item.open == '1' ? 'active' : ''}"" data-length="${item.links && item.links.length ? 1 : 0}" data-link="${item.link}">
            <div class="link-list">
                <span class="text">${item.title}</span>
                ${ item.links && item.links.length > 0 ?
                    `<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>`
                    : ''
                }
            </div>
            <div class="nav-img-list-box">
                ${ item['model-type'] ?
                    `<div class="list-title">By Occasion</div>`
                    : ''
                }
                
                <div class="img-text-lists">
                    ${ item.links && item.links.length > 0 ?
                        item.links.map((childItem) => {
                            return `<div class="list">
                                <a href="${childItem.link}" class="img-wrap">
                                    ${imgTag(childItem)}
                                </a>
                                <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                            </div>
                            `
                        }).join('')
                        : ''
                    }
                </div>
            </div>
        </li>`
    })

    html += `</ul>`

    return html
}

// 移动端 scene 类目的html结构（第一层：分类列表）
function initSceneM (items) {
    let html = '<ul class="nav-menu-section nav-menu-section-scene child-main-model child-main-model__3">'

    if (items.links && items.links.length > 0) {
        items.links.forEach(item => {
            const hasScenes = item.scenes && item.scenes.length > 0
            // 存储到 childItems 供第二层使用
            childItems[item.id] = {
                title: item.title || '',
                link: item.link || '',
                scenes: item.scenes || []
            }

            html += `<li class="li li-scene" data-id="${item.id}" data-link="${item.link}" data-has-scenes="${hasScenes}">
                <div class="link-list">
                    <span class="text">${item.title}</span>
                    ${hasScenes ? '<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>' : ''}
                </div>
            </li>`
        })
    }

    html += `</ul>`

    return html
}

// 移动端 scene 类目的html结构（第二层：scenes 产品列表）
function initSceneMChild (item) {
    let html = `<div class="list-nav-title">${item.title}<a href="${item.link}" class="view-all">
                View More >
            </a></div><ul class="nav-menu-section child-main-model__2 scene-child-list">`

    if (item.scenes && item.scenes.length > 0) {
        item.scenes.forEach(sceneItem => {
            html += `<li class="li">
                <a href="${sceneItem.link}" class="img-wrap">
                    ${imgTag(sceneItem)}
                </a>
                <a href="${sceneItem.link}" class="li-title">${sceneItem.title}</a>
            </li>`
        })
    }

    html += `</ul>`

    return html
}

// 移动端 up-down-text-img 类目的html结构
function initUpDowntImgTextM (items) {
    let html = '<ul class="nav-menu-section child-main-model child-main-model__4">'

    items.forEach(item => {
        html += `<li class="li li-up-down ${item.open == '1' ? 'active' : ''}" data-length="${item.links && item.links.length ? 1 : 0}" data-link="${item.link}">
            <div class="link-list">
                <span class="text">${item.title}</span>
                ${ item.links && item.links.length > 0 ?
                    `<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>`
                    : ''
                }
            </div>
            
            ${
                item.type == 'img-text' ?
                `<div class="img-text-lists">
                    ${ item.links && item.links.length > 0 ?
                        item.links.map((childItem) => {
                            return `<div class="list">
                                <a href="${childItem.link}" class="img-wrap">
                                    ${imgTag(childItem)}
                                </a>
                                <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                            </div>`
                        }).join('')
                        : ''
                    }
                </div>`
                :
                `<div class="nav-img-list-box">
                    <div class="link-lists">
                        ${ item.links && item.links.length > 0 ?
                            item.links.map((childItem) => {
                                return `<div class="list">
                                    <a href="${childItem.link}" class="list-title">${childItem.title}</a>
                                </div>`
                            }).join('')
                            : ''
                        }
                    </div>
                </div>`
            }
        </li>`
    })

    html += `</ul>`

    return html
}

// 移动端 other 类目的html结构
function initOtherM (items) {
    let html = '<ul class="nav-menu-section child-main-model__5">'

    items.forEach(item => {
        html += `<li class="li">
            <svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${item.icon}"></use></svg>
            <a href="${item.link}" class="text">${item.title}</a>
        </li>`
    })

    html += `</ul>`

    return html
}

// pc 端 img-text 类目的html结构
function initImgTextPc (items) {
    let html = '<div class="child-nav-main child-main-model-1">'

    items.forEach(item => {
        html += `<div class="text-img-link">
            <a href="${item.link}" class="img-wrap">
                ${imgTag(item)}
            </a>
            <a href="${item.link}" class="link-title">${item.title}</a>
        </div>`
    })

    html += `</div>`

    return html
}

// pc up-down 类目的html结构
function initUpDowntPc (items, link, title) {
    let navList = ''
    let navActiveList = ''
    let firstActive = null
    items.forEach((item, index) => {
        if (firstActive === null && item.links && item.links.length > 0) {
            firstActive = index
            
            navActiveList = initActiveUpDowntPc(item)
        }
        navList += `<a data-id="${item.title}" class="list list-hover justify-between align-items-center ${firstActive === index ? 'active' : ''}">${item.title} ${item.links && item.links.length ? '<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>' : ''}</a>`

        if (!childItems[item.title] || !childItems[item.title].links || childItems[item.title].links == undefined) {
            childItems[item.title] = {
                links: item.links
            }
            if (item['model-type']) childItems[item.title]['model-type'] = item['model-type']
        }
    })

    const html = `<div class="child-nav-main child-main-model-2">
        <div class="menu-child">
            <div class="lists">
                ${navList}
            </div>

            <div class="list-all">
                <a href="${link}" class="all-link">View More ${title}</a>
            </div>
        </div>
        <div class="menu-active-lists">
            <div class="lists">
                ${navActiveList}
            </div>
        </div>
    </div>`

    return html
}

// pc scene 类目的html结构
function initScenePc (items,title) {
    let navList = ''
    let navActiveList = ''
    let firstActive = null

    if (items.links && items.links.length > 0) {
        items.links.forEach((item, index) => {
            // 找到第一个有scenes的item作为默认激活项
            if (firstActive === null && item.scenes && item.scenes.length > 0) {
                firstActive = index
                navActiveList = initActiveScenePc(item)
            }

            // 判断是否有scenes来决定是否显示箭头
            const hasScenes = item.scenes && item.scenes.length > 0

            navList += `<a data-id="${item.id}" class="list list-hover list-scene justify-between align-items-center ${firstActive === index ? 'active' : ''}">${item.title}${hasScenes ? '<svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#le_svg_arrow_bttom"></use></svg>' : ''}</a>`

            // 存储每个link的scenes到childItems（使用 id 作为 key 避免重名冲突）
            childItems[item.id] = {
                title: item.title || '',
                link: item.link || '',
                links: item.links || [],
                scenes: item.scenes || []
            }
            if (item['model-type']) childItems[item.id]['model-type'] = items.type

            // 预加载 scenes 图片
            if (item.scenes && item.scenes.length > 0) {
                item.scenes.forEach(scene => {
                    if (scene.img_url) {
                        const img = new Image()
                        img.src = scene.img_url
                    }
                })
            }
        })
    }

    // 如果没有在links中找到scenes，使用顶层的scenes作为后备
    if (!navActiveList && items.scenes && items.scenes.length > 0) {
        navActiveList = initActiveScenePc(items)
    }

    const html = `<div class="child-nav-main child-main-model-2">
        <div class="menu-child">
            <div class="lists">
                ${navList}
            </div>

            <div class="list-all">
                <a href="${items.link}" class="all-link">View More ${title}</a>
            </div>
        </div>
        ${navActiveList}
    </div>`

    return html
}

// pc 二级菜单滑入时，获取当前二级菜单up-down 类目的html结构
function initActiveUpDowntPc (item) {
    let childNavList = ''
    
    item.links.forEach(childItem => {
        childNavList += `<div class="list">
            <a href="${childItem.link}" class="img-wrap">
                ${imgTag(childItem)}
            </a>
            <div class="tag">Hot</div>
            <a href="${childItem.link}" class="link-title">${childItem.title}</a>
        </div>`
    })

    return childNavList
}

// pc 二级菜单滑入时，获取当前二级菜单scene 类目的html结构（内部cards，用于hover切换）
function initActiveScenePcInner (item) {
    let childNavList = ''

    item.forEach(childItem => {
        childNavList += `<div class="list">
            <a href="${childItem.link}" class="img-wrap">
                ${imgTag(childItem)}
            </a>
            <a href="${childItem.link}" class="link-title">${childItem.title}</a>
        </div>`
    })

    return childNavList
}

// pc 二级菜单scene 类目的完整html结构（包含外层容器，用于初始化）
function initActiveScenePc (item) {
    const childNavList = initActiveScenePcInner(item.scenes)

    const navActiveList = `<div class="menu-active-lists-model_2">
            <div class="menu-title">${item.title}<a href="${item.link}" class="view-all">
                View More >
            </a></div>
            <div class="lists">
                ${childNavList}
            </div>
        </div>`

    return navActiveList
}

// pc 二级菜单滑入时，获取当前二级菜单img-text 类目的html结构
function initUpDowntImgTextPc (items) {
    let html = '<div class="child-nav-main child-main-model-3"><div class="nav-lists">'

    items.forEach(item => {
        html += `
            ${
                item.type == 'img-text' ?
                `<div class="nav-list width39">
                    <div class="list-title">${item.title}</div>
                    <div class="img-text-lists">
                        ${ item.links && item.links.length > 0 ?
                            item.links.map((childItem) => {
                                return `<div class="img-text-list">
                                    <a href="${childItem.link}" class="img-wrap">
                                        ${imgTag(childItem)}
                                    </a>
                                    <div class="img-text-link">
                                        <a href="${childItem.link}" class="link">${childItem.title}</a>
                                    </div>
                                </div>`
                            }).join('')
                            : ''
                        }
                    </div>
                </div>`
                :
                `<div class="nav-list">
                    <div class="list-title">${item.title}</div>
                    ${ item.links && item.links.length > 0 ?
                        item.links.map((childItem) => {
                            return `<a href="${childItem.link}" class="nav-link">${childItem.title}</a>`
                        }).join('')
                        : ''
                    }
                </div>`
            }
        `
    })

    html += `</div></div>`

    return html
}

// pc 二级菜单滑入时，获取当前二级菜单other 类目的html结构
function initOtherPc (items) {
    let html = '<div class="child-nav-main child-main-model-4"><div class="nav-lists">'

    items.forEach(item => {
        html += `<a href="${item.link}" class="li">
            <svg class="le_icon" viewBox="0 0 64 64"><use class="le_svg_symbol" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${item.icon}"></use></svg>
            <span class="text">${item.title}</span>
        </a>`
    })

    html += `</div></div>`

    return html
}